angular.module('cfn').factory('templatingService', function() {
  'use strict';
  var TOKEN_PATTERN = /%%(\w+).?([^%]*)%%/g;

  return {
    isTemplate: function(someString) {
      return !!someString.match(TOKEN_PATTERN);
    },
    render: function(template, handlers) {
      return template.replace(TOKEN_PATTERN, function(m, handler, token) {
        return handlers[handler] && handlers[handler](token);
      });
    }
  };
});
